import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../assets/css/admin/addPackage.css";

import { db } from "../../firebase/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import {
    CLOUDINARY_URL,
    UPLOAD_PRESET
} from "../../services/cloudinary";

function AddPackage() {

    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [price, setPrice] = useState("");
    const [features, setFeatures] = useState("");

    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState("");

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
    title: "",
    price: "",
    image: ""
});

const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    /*=========================================================
                        IMAGE SELECTION
    =========================================================*/

   const handlePackageImage = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    setImage(file);

    setPreview(URL.createObjectURL(file));

    setErrors({
        ...errors,
        image: ""
    });

};


    /*=========================================================
                        CLOUDINARY UPLOAD
    =========================================================*/

    const uploadImage = async () => {

        const formData = new FormData();

        formData.append("file", image);
        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await fetch(CLOUDINARY_URL, {

            method: "POST",
            body: formData

        });

        const data = await response.json();

        if (!data.secure_url) {

            throw new Error("Cloudinary Upload Failed");

        }

        return data.secure_url;

    };

    /*=========================================================
                        SAVE PACKAGE
    =========================================================*/

    const savePackage = async () => {

       const validationErrors = {};

if (!title.trim()) {

    validationErrors.title =
        "Package name is required.";

}

if (!price) {

    validationErrors.price =
        "Package price is required.";

}

if (!image) {

    validationErrors.image =
        "Package image is required.";

}

if (Object.keys(validationErrors).length > 0) {

    setErrors(validationErrors);

    return;

}

setErrors({
    title: "",
    price: "",
    image: ""
});

        try {

            setLoading(true);

            const imageUrl = await uploadImage();

            await addDoc(collection(db, "packages"), {

                title,

                price: `Starting at ₹${price}`,

                image: imageUrl,

                features: features
                    .split("\n")
                    .filter(item => item.trim() !== ""),

                createdAt: serverTimestamp()

            });

         setPopup({
    show: true,
    type: "success",
    message: "Package Added Successfully"
});

setTimeout(() => {

    navigate("/admin/manage-packages");

}, 2000);

        }

        catch (error) {

            console.error(error);

            setPopup({
    show: true,
    type: "error",
    message: "Failed to Add Package"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <>
        {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>

                {popup.message}

            </p>

        </div>

    </div>

)}

        <div className="add-package-page">

            <div className="add-package-wrapper">

                {/*=====================================================
                                HEADER
                =====================================================*/}

                <div className="add-package-header">

                    <h1 className="add-package-title">

                        Add Premium Package

                    </h1>

                    <p className="add-package-subtitle">

                        Create a premium photography package with
                        pricing, cover image and package features.

                    </p>

                </div>

                {/*=====================================================
                                FORM CARD
                =====================================================*/}

                <div className="add-package-card">

                    {/* Package Name */}

                    <div className="add-package-field">

                        <label className="add-package-label">

                            Package Name

                        </label>

                        <input

                            type="text"

                            className="add-package-input"

                            placeholder="Wedding Photography"

                            value={title}

                           onChange={(e) => {

    setTitle(e.target.value);

    setErrors({
        ...errors,
        title: ""
    });

}}
/>
{errors.title && (

    <p className="validation-error">

        {errors.title}

    </p>

)}

                    </div>

                    {/* Price */}

                    <div className="add-package-field">

                        <label className="add-package-label">

                            Starting Price

                        </label>

                        <input

                            type="number"

                            className="add-package-input"

                            placeholder="25000"

                            value={price}
                           onChange={(e) => {

    setPrice(e.target.value);

    setErrors({
        ...errors,
        price: ""
    });

}}
 />
 {errors.price && (

    <p className="validation-error">

        {errors.price}

    </p>

)}

                    </div>

                    {/* Image */}

                    <div className="add-package-field">

                        <label className="add-package-label">

                            Package Cover Image

                        </label>

                        <input

                            type="file"

                            accept="image/*"

                            className="add-package-file"

                            onChange={handlePackageImage}

                        />
                        {errors.image && (

    <p className="validation-error">

        {errors.image}

    </p>

)}

                    </div>

                    {/* Preview */}

                    {

                        preview && (

                            <div className="add-package-preview-box">

                                <img

                                    src={preview}

                                    alt="Preview"

                                    className="add-package-preview-image"

                                />

                            </div>

                        )

                    }

                    {/* Features */}

                    <div className="add-package-field">

                        <label className="add-package-label">

                            Package Features

                        </label>

                        <textarea

                            className="add-package-textarea"

                            rows={8}

                            placeholder={`Enter one feature per line

Example:

Candid Photography
Drone Photography
LED Wall
Live Streaming
Premium Album
2 Photographers
1 Cinematographer
Highlight Video`}

                            value={features}

                            onChange={(e) =>
                                setFeatures(e.target.value)
                            }

                        />

                    </div>

                    {/* Button */}

                    <button

                        className="add-package-save-btn"

                        onClick={savePackage}

                        disabled={loading}

                    >

                        {

                            loading

                                ? "Uploading..."

                                : "Save Package"

                        }

                    </button>

                </div>

            </div>

        </div>
    </>
    );

}

export default AddPackage;